import axios from 'axios'
import { i18n } from '../main'

const apiClient = axios.create({
  baseURL:  `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  timeout: 10000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.authorization = 'Bearer '+ token
    }
    config.headers.lang = i18n.locale.toUpperCase()
    return config
  },
  (error) => Promise.reject(error),
)

const apiFileClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: true,
  headers: {
    Accept: 'application/pdf',
    'Content-type': 'application/json'
  },
  responseType: 'blob'
})

apiFileClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.authorization = 'Bearer ' + token
    }
    return config
  },
  (error) => Promise.reject(error),
)

export default {
  downloadQRCodesPDF(body) {
    return apiFileClient.post(`/export/products/qr/pdf`, body)
  },
  downloadSingleQRCodePDF(body) {
    return apiFileClient.post(`/export/unit/product/qr/pdf`, body)
  }
}
